module.exports = __webpack_public_path__ + "img/search.36c522c4.svg";